module.exports = __webpack_public_path__ + "img/ewm.2bfee5b5.png";